import * as React from 'react';
import { LazyImage } from '@grandvisionhq/common';

const FooterPaymentOptions = ({ items  })=>{
    if (!items.length) {
        return null;
    }
    var _description;
    return /*#__PURE__*/ React.createElement("div", {
        className: "footer__payment"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "footer__payment-items"
    }, items.map((item, index)=>/*#__PURE__*/ React.createElement("li", {
            key: `payment-item-${index}`,
            className: "footer__payment-item"
        }, /*#__PURE__*/ React.createElement(LazyImage, {
            src: item.url,
            alt: (_description = item.description) !== null && _description !== void 0 ? _description : '',
            width: 48,
            height: 30
        }))
    )));
};

export { FooterPaymentOptions };
//# sourceMappingURL=FooterPaymentOptions.js.map
